globalThis.Client = class Client {
  constructor(resource) {
    globalThis.CLIENT = this;
    this.abort = new AbortController();
    this.server = new Server(resource);
    this.server.addEventListener(
      "message",
      this.onMessage.bind(this),
      this.abort,
    );
    this.server.addEventListener("close", this.onClose.bind(this), this.abort);
    if (this.server.open) this.onOpen();
    else
      this.server.addEventListener("open", this.onOpen.bind(this), this.abort);
  }

  remove() {
    this.abort.abort();
    this.server.remove();
    delete globalThis.CLIENT;
  }

  jump(index) {
    this.server.postMessage(new Message("jump", index));
  }

  move(index, direction, sprinting) {
    this.server.postMessage(
      new Message("move", { index, direction, sprinting }),
    );
  }

  moveVertically(index, direction) {
    this.server.postMessage(
      new Message("movevertically", { index, direction }),
    );
  }

  addPlayer(index) {
    this.server.postMessage(new Message("addplayer", index));
  }

  removePlayer(index) {
    this.server.postMessage(new Message("removeplayer", index));
  }

  addBlock(x, y, index) {
    this.server.postMessage(new Message("addblock", { x, y, index }));
  }

  removeBlockAt(x, y) {
    this.server.postMessage(new Message("removeblock", { x, y }));
  }

  setWorldSize(x, y) {
    this.server.postMessage(new Message("setworldsize", { x, y }));
  }

  clearWorld() {
    this.server.postMessage(new Message("clearworld"));
  }

  loadWorld(data) {
    if (typeof data == "object") data = data.data;
    this.server.postMessage(new Message("loadworld", data));
  }

  onOpen() {
    const { profile } = globalThis.STORE;
    this.server.postMessage(new Message("connect", { profile }));
  }

  onClose() {
    new Dialogue({
      title: "Disconnected",
      body: "Connection has been closed.",
      closable: false,
      okText: "Exit",
      action: () => globalThis.ROUTER.goto("/"),
      center: true,
    });
  }

  onMessage(event) {
    const { type, body } = event.data;
    switch (type) {
      case "addconnection":
        globalThis.WORLD.connect(body);
        break;
      case "removeconnection":
        globalThis.WORLD.disconnect(body.id);
        break;
      case "block":
        globalThis.WORLD.updateBlock(body);
        break;
      case "player":
        globalThis.WORLD.updatePlayer(body);
        break;
      case "addplayer":
        globalThis.WORLD.addPlayer(...body);
        break;
      case "removeplayer":
        globalThis.WORLD.removePlayer(...body);
        break;
      case "addblock":
        globalThis.WORLD.addBlock(
          new Block(body.position.x, body.position.y, body.index),
        );
        break;
      case "removeblock":
        globalThis.WORLD.removeAt(body.x, body.y);
        break;
      case "worldsize":
        globalThis.WORLD.setSize(body.x, body.y);
        break;
      case "chat":
        globalThis.CHAT.push(body.message, body);
        break;
      case "clear":
        dispatchEvent(new Event("worldclear"));
        break;
      case "loadstart":
        dispatchEvent(new Event("worldloadstart"));
        break;
      case "loadend":
        dispatchEvent(new Event("worldload"));
        break;
    }
  }
};
